import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OffersGrid.css';
import { HandDrawnButton } from '../HandDrawnButton/HandDrawnButton';
import { NiceLink } from '../NiceLink/NiceLink';

interface OfferData {
  id: number;
  image: string;
  tag?: string;
  title: string;
  moreLink: string;
  moreLabel: string;
}

interface TagProps {
  text: string;
}

const Tag: React.FC<TagProps> = ({ text }) => {
  return (
    <div className="offers-grid__tag">
      <div className="offers-grid__tag-border" />
      <div className="offers-grid__tag-text">
        <p>{text}</p>
      </div>
    </div>
  );
};

interface OfferCardProps {
  offer: OfferData;
}

const OfferCard: React.FC<OfferCardProps> = ({ offer }) => {
  const navigate = useNavigate();

  const showLinks = true;

  return (
    <div className="offers-grid__card">
      <div className="offers-grid__card-image-container">
        <img
          src={offer.image}
          alt={offer.title}
          className="offers-grid__card-image"
        />
        {
          offer.tag && (
          <div className="offers-grid__card-tag">
            <Tag text={offer.tag} />
          </div>
          )
        }
      </div>
      <div className="offers-grid__card-content">
        <div className="offers-grid__card-title">
          <p>{offer.title}</p>
        </div>
        {
          showLinks &&
          <div className="offers-grid__card-link-container">
            <NiceLink
              text={offer.moreLabel}
              onClick={() => navigate(offer.moreLink)}
              className="offers-grid__link"
            />
          </div>
        }
      </div>
    </div>
  );
};

interface OffersGridProps {
  heading: string;
  description?: string;
  ctaLabel?: string;
  ctaLink?: string;
  offers: OfferData[];
}

export const OffersGrid: React.FC<OffersGridProps> = ({ heading, description, ctaLabel, ctaLink, offers }) => {
  const navigate = useNavigate();

  const showLinks = true;

  return (
    <section className="offers-grid" data-scroll-section>
      <div className="offers-grid__inner">
        <div className="offers-grid__text">
          <h2 className="offers-grid__text-title">{heading}</h2>
          <div className="offers-grid__text-description">
            <p>
              {description}
            </p>
          </div>
          {
            showLinks && ctaLabel && ctaLink && (
            <div className="offers-grid__actions">
              <HandDrawnButton
                text={ctaLabel}
                onClick={() => navigate(ctaLink)}
                variant="brand"
                color="awasi"
                animation="stroke-to-fill"
                size="normal"
                className="offers-grid__button"
              />
            </div>
            )
          }
        </div>
        <div className="offers-grid__packages">
          {offers.map((offer) => (
            <OfferCard key={offer.id} offer={offer} />
          ))}
        </div>
      </div>
    </section>
  );
};